// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voIxo9Ig7liTOw_7FISr {
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 9999;
  justify-content: center;
  align-items: center;
  display: flex !important;
}
@media (min-width: 1000px) {
  .voIxo9Ig7liTOw_7FISr {
    align-items: baseline;
    padding-top: 6vh;
  }
}

@media (min-width: 1000px) {
  .IsVWCyNbkGjRy9ble6tT {
    padding-top: 4vh;
  }
}

.pxufx_gc1T_0Ufeb3bnL {
  background: none;
  border: none;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
}

.UVP0jDnyMredDfF_2r8B, .DEq52vlMXogcH5skSgwH, .r76tjdLpvH_N4VSkjFQ9, .dzLNcy_eMD9wxvKRB7CB, .Qv5cHhHaPBegTFz89ZtD, .HrQmtQ5M2dlXaNczh9AT, .Rakgur6RRGd1dvXTQCcu {
  overflow: hidden;
  width: 100%;
  min-height: fit-content;
  max-width: 800px;
  border-radius: 0;
  overflow-x: hidden;
  background: #08090A;
}
@media (max-width: 1000px) {
  .UVP0jDnyMredDfF_2r8B, .DEq52vlMXogcH5skSgwH, .r76tjdLpvH_N4VSkjFQ9, .dzLNcy_eMD9wxvKRB7CB, .Qv5cHhHaPBegTFz89ZtD, .HrQmtQ5M2dlXaNczh9AT, .Rakgur6RRGd1dvXTQCcu {
    max-width: 96wv;
    max-height: 92vh;
    min-height: unset;
  }
}

.Rakgur6RRGd1dvXTQCcu {
  max-width: 400px !important;
}

.HrQmtQ5M2dlXaNczh9AT {
  max-width: 500px !important;
}

.Qv5cHhHaPBegTFz89ZtD {
  max-width: 600px !important;
}
@media (max-height: 800px) {
  .Qv5cHhHaPBegTFz89ZtD {
    max-width: 60vw;
  }
}

.dzLNcy_eMD9wxvKRB7CB {
  max-width: 800px !important;
}

.r76tjdLpvH_N4VSkjFQ9 {
  max-width: min(1100px, 80vw);
}
@media (max-width: 1000px) {
  .r76tjdLpvH_N4VSkjFQ9 {
    max-width: min(1100px, 96vw);
    max-height: 92vh;
    min-height: unset;
  }
}

.DEq52vlMXogcH5skSgwH {
  max-width: 80vw !important;
}

.F3u0q81xt07OW8Oxvi6g {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: none;
  border: none;
  border-radius: 0;
  padding: 24px 32px;
  box-shadow: none;
}
@media ((max-width: 1600px) or (max-height: 850px)) {
  .F3u0q81xt07OW8Oxvi6g {
    padding: 24px;
  }
}
@media (max-width: 1000px) {
  .F3u0q81xt07OW8Oxvi6g {
    padding: 16px;
  }
}

.slbdCEenmhDq_o3i73fn {
  font-family: Bai Jamjuree;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: #FBFBFB;
}

.yCLBf3WFiAaxwDtTDaW5 {
  height: 32px;
  width: 32px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: white;
}
.yCLBf3WFiAaxwDtTDaW5:hover {
  background: rgba(255, 255, 255, 0.1);
}

.Bo_p0hnzHOqsYFtGEI2l, .lXtHuvEN_91voNMcbI9H, .lF3GFscsIw5uzYTy_O49 {
  background: none;
  border: none;
  padding: 0;
  color: rgba(255, 255, 255, 0.6980392157);
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
}
@media (max-width: 1000px) {
  .Bo_p0hnzHOqsYFtGEI2l, .lXtHuvEN_91voNMcbI9H, .lF3GFscsIw5uzYTy_O49 {
    max-height: calc(100vh - 8rem);
  }
}

.lF3GFscsIw5uzYTy_O49 {
  max-height: 74vh;
}
@media (max-width: 1000px) {
  .lF3GFscsIw5uzYTy_O49 {
    max-height: calc(100vh - 10rem);
  }
}

.lXtHuvEN_91voNMcbI9H {
  max-height: 68vh;
}
@media (max-width: 1000px) {
  .lXtHuvEN_91voNMcbI9H {
    max-height: calc(100vh - 12rem);
  }
}

.ZcPIo3ijErs5MtWjaJoK {
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, #8D71FF 0%, rgba(141, 113, 255, 0) 100%);
}

.ficVHeSN2JtW4uKhrPuy {
  padding: 32px;
  border-width: 0px 1px 1px 1px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.2);
  border-radius: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
@media ((max-width: 1600px) or (max-height: 850px)) {
  .ficVHeSN2JtW4uKhrPuy {
    padding: 24px;
  }
}
@media (max-width: 1000px) {
  .ficVHeSN2JtW4uKhrPuy {
    padding: 16px;
  }
}
.ficVHeSN2JtW4uKhrPuy > * {
  margin: 0;
}

.rUjGUqI0_BiXYvxgc18m {
  flex-grow: 2;
}

.XHYsZVBnP7JQtcmp9Vhg {
  height: 1px;
  width: 100%;
  background: linear-gradient(to right, rgb(69, 174, 255), rgba(50, 40, 92, 0));
}`, "",{"version":3,"sources":["webpack://./src/Components/Modal/Modal.module.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;AACD;AAAC;EAVD;IAWE,qBAAA;IACA,gBAAA;EAGA;AACF;;AAEC;EADD;IAEE,gBAAA;EAEA;AACF;;AACA;EACC,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AAED;;AACA;EAEC,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AACD;AAAC;EATD;IAUE,eAAA;IACA,gBAAA;IACA,iBAAA;EAGA;AACF;;AAAA;EAEC,2BAAA;AAED;;AACA;EAEC,2BAAA;AACD;;AAEA;EAEC,2BAAA;AAAD;AACC;EAHD;IAIE,eAAA;EAEA;AACF;;AAEA;EAEC,2BAAA;AAAD;;AAGA;EAEC,4BAAA;AADD;AAEC;EAHD;IAIE,4BAAA;IACA,gBAAA;IACA,iBAAA;EACA;AACF;;AAEA;EAEC,0BAAA;AAAD;;AAGA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAAD;AACC;EAVD;IAWE,aAAA;EAEA;AACF;AADC;EAbD;IAcE,aAAA;EAIA;AACF;;AADA;EACC,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAID;;AADA;EACC,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAID;AAHC;EACC,oCAAA;AAKF;;AADA;EACC,gBAAA;EACA,YAAA;EACA,UAAA;EACA,wCAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAID;AAHC;EARD;IASE,8BAAA;EAMA;AACF;;AAHA;EAEC,gBAAA;AAKD;AAJC;EAHD;IAIE,+BAAA;EAOA;AACF;;AAJA;EAEC,gBAAA;AAMD;AALC;EAHD;IAIE,+BAAA;EAQA;AACF;;AALA;EACC,WAAA;EACA,WAAA;EACA,2EAAA;AAQD;;AALA;EACC,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,sCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAQD;AAPC;EAVD;IAWE,aAAA;EAUA;AACF;AATC;EAbD;IAcE,aAAA;EAYA;AACF;AAXC;EACC,SAAA;AAaF;;AATA;EACC,YAAA;AAYD;;AATA;EACE,WAAA;EACA,WAAA;EACA,6EAAA;AAYF","sourcesContent":[".modal {\r\n\tposition: absolute;\r\n\twidth: 100vw;\r\n\theight: 100vh;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tz-index: 9999;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tdisplay: flex !important;\r\n\t@media (min-width: 1000px) {\r\n\t\talign-items: baseline;\r\n\t\tpadding-top: 6vh;\r\n\r\n\t}\r\n}\r\n\r\n.modalWithFooter {\r\n\t@media (min-width: 1000px) {\r\n\t\tpadding-top: 4vh;\r\n\t}\r\n}\r\n\r\n.modalContent {\r\n\tbackground: none;\r\n\tborder: none;\r\n\tborder-radius:  0;\r\n\tbox-shadow: none;\r\n\tpadding: 0;\r\n}\r\n\r\n.modalDialog {\r\n\r\n\toverflow: hidden;\r\n\twidth: 100%;\r\n\tmin-height: fit-content;\r\n\tmax-width: 800px;\r\n\tborder-radius: 0;\r\n\toverflow-x: hidden;\r\n\tbackground: #08090A;\r\n\t@media (max-width: 1000px) {\r\n\t\tmax-width: 96wv;\r\n\t\tmax-height: 92vh;\r\n\t\tmin-height: unset;\r\n\t}\r\n}\r\n\r\n.modalDialogSmall {\r\n\t@extend .modalDialog;\r\n\tmax-width: 400px !important;\r\n}\r\n\r\n.modalDialogMediumSmall {\r\n\t@extend .modalDialog;\r\n\tmax-width: 500px !important;\r\n}\r\n\r\n.modalDialogMedium {\r\n\t@extend .modalDialog;\r\n\tmax-width: 600px !important;\r\n\t@media (max-height: 800px) {\r\n\t\tmax-width: 60vw;\r\n\t}\r\n\r\n}\r\n\r\n.modalDialogLarge{\r\n\t@extend .modalDialog;\r\n\tmax-width: 800px !important;\r\n}\r\n\r\n.modalDialogExtraLarge {\r\n\t@extend .modalDialog;\r\n\tmax-width: min(1100px, 80vw);\r\n\t@media (max-width: 1000px) {\r\n\t\tmax-width: min(1100px, 96vw);\r\n\t\tmax-height: 92vh;\r\n\t\tmin-height: unset;\r\n\t}\r\n}\r\n\r\n.modalDialogFull {\r\n\t@extend .modalDialog;\r\n\tmax-width: 80vw !important;\r\n}\r\n\r\n.modalHeader {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tbackground: none;\r\n\tborder: none;\r\n\tborder-radius: 0;\r\n\tpadding: 24px 32px;\r\n\tbox-shadow: none;\r\n\t@media ((max-width: 1600px) or (max-height: 850px)) {\r\n\t\tpadding: 24px;\r\n\t}\r\n\t@media (max-width: 1000px) {\r\n\t\tpadding: 16px;\r\n\t}\r\n}\r\n\r\n.modalHeaderTitle {\r\n\tfont-family: Bai Jamjuree;\r\n\tfont-weight: 600;\r\n\tfont-size: 24px;\r\n\tline-height: 32px;\r\n\tcolor: #FBFBFB;\r\n}\r\n\r\n.modalHeaderCloseButtonContainer {\r\n\theight: 32px;\r\n\twidth: 32px;\r\n\tcursor: pointer;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tborder-radius: 50%;\r\n\tcolor: white;\r\n\t&:hover {\r\n\t\tbackground: rgba(255, 255, 255, 0.1);\r\n\t}\r\n}\r\n\r\n.modalBody {\r\n\tbackground: none;\r\n\tborder: none;\r\n\tpadding: 0;\r\n\tcolor: #FFFFFFB2;\r\n\tmax-height: 80vh;\r\n\toverflow-y: auto;\r\n\toverflow-x: hidden;\r\n\t@media (max-width: 1000px) {\r\n\t\tmax-height: calc(100vh - 8rem);\r\n\t}\r\n}\r\n\r\n.modalBodyWithFooter {\r\n\t@extend .modalBody;\r\n\tmax-height: 74vh;\r\n\t@media (max-width: 1000px) {\r\n\t\tmax-height: calc(100vh - 10rem);\r\n\t}\r\n}\r\n\r\n.modalBodyWithHeaderWithFooter {\r\n\t@extend .modalBody;\r\n\tmax-height: 68vh;\r\n\t@media (max-width: 1000px) {\r\n\t\tmax-height: calc(100vh - 12rem);\r\n\t}\r\n}\r\n\r\n.modalFooterDivider {\r\n\twidth: 100%;\r\n\theight: 1px;\r\n\tbackground: linear-gradient(90deg, #8D71FF 0%, rgba(141, 113, 255, 0) 100%);\r\n}\r\n\r\n.modalFooter {\r\n\tpadding: 32px;\r\n\tborder-width: 0px 1px 1px 1px;\r\n\tborder-style: solid;\r\n\tborder-color: #FFFFFF33;\r\n\tborder-radius: 0;\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\t@media ((max-width: 1600px) or (max-height: 850px)) {\r\n\t\tpadding: 24px;\r\n\t}\r\n\t@media (max-width: 1000px) {\r\n\t\tpadding: 16px;\r\n\t}\r\n\t&>* {\r\n\t\tmargin: 0;\r\n\t}\r\n}\r\n\r\n.confirmButton {\r\n\tflex-grow: 2;\r\n}\r\n\r\n.fadingDivider {\r\n  height: 1px;\r\n  width: 100%;\r\n  background: linear-gradient(to right, rgba(69, 174, 255, 1), rgba(50, 40, 92, 0));\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `voIxo9Ig7liTOw_7FISr`,
	"modalWithFooter": `IsVWCyNbkGjRy9ble6tT`,
	"modalContent": `pxufx_gc1T_0Ufeb3bnL`,
	"modalDialog": `UVP0jDnyMredDfF_2r8B`,
	"modalDialogFull": `DEq52vlMXogcH5skSgwH`,
	"modalDialogExtraLarge": `r76tjdLpvH_N4VSkjFQ9`,
	"modalDialogLarge": `dzLNcy_eMD9wxvKRB7CB`,
	"modalDialogMedium": `Qv5cHhHaPBegTFz89ZtD`,
	"modalDialogMediumSmall": `HrQmtQ5M2dlXaNczh9AT`,
	"modalDialogSmall": `Rakgur6RRGd1dvXTQCcu`,
	"modalHeader": `F3u0q81xt07OW8Oxvi6g`,
	"modalHeaderTitle": `slbdCEenmhDq_o3i73fn`,
	"modalHeaderCloseButtonContainer": `yCLBf3WFiAaxwDtTDaW5`,
	"modalBody": `Bo_p0hnzHOqsYFtGEI2l`,
	"modalBodyWithHeaderWithFooter": `lXtHuvEN_91voNMcbI9H`,
	"modalBodyWithFooter": `lF3GFscsIw5uzYTy_O49`,
	"modalFooterDivider": `ZcPIo3ijErs5MtWjaJoK`,
	"modalFooter": `ficVHeSN2JtW4uKhrPuy`,
	"confirmButton": `rUjGUqI0_BiXYvxgc18m`,
	"fadingDivider": `XHYsZVBnP7JQtcmp9Vhg`
};
export default ___CSS_LOADER_EXPORT___;
